import { Component, OnInit } from '@angular/core';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-matchtickets',
  templateUrl: './matchtickets.component.html',
  styleUrls: ['./matchtickets.component.scss']
})
export class MatchticketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    jQuery(".faq-title ").on("click",function() {
      jQuery(".faq-title").removeClass('active');	  
      if (jQuery(this).toggleClass('active')) {
        // do nothing
      } 
      return false;
    });
  }

}
